const routes = {
  Bookmarks: () => `/bookmarks`,
  UserCompetences: (userId: string) => `/user-profile/${userId}/competences`,
};

export default routes;
